/**
 * 業態別媒体区分
 */
export class VMediumDutiesForm {

  /** . */
  MediumType = '';

  /** . */
  MediumName = '';

  /** . */
  StopOrderCode = '';

  /** . */
  ProgressWorkNum = '';

  /** . */
  ProgressWorkName = '';

  /** . */
  ReceiptEOrderCode = '';

  /** . */
  ReceiptECatalogId = '';

  /** . */
  MediumTypeClass = '';

  /** . */
  DutiesFormDiv = '';

  /** . */
  MediumTypeName = '';
}
